import { render, staticRenderFns } from "./inspection-questions-classification-chart.component.vue?vue&type=template&id=594ea0ef&scoped=true"
import script from "./inspection-questions-classification-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./inspection-questions-classification-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./inspection-questions-classification-chart.component.vue?vue&type=style&index=0&id=594ea0ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ea0ef",
  null
  
)

export default component.exports